
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
    light: {
      type: Boolean,
      default: false,
    },
    isHero: {
      type: Boolean,
      default: false,
    },
    hidePostType: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
    };
  },
  computed: {
    postType () {
      return this.post.type === `post` ? `News`
        : this.post.type === `match_preview` ? `Preview`
          : this.deslugify(this.post.type);
    },
    subtitle () {
      return this.post.acf.subtitle || false;
    },
    date () {
      return this.post?.date ? this.getDate(this.post.date) : ``;
    },
    author () {
      return this.post.acf.post_author;
    },
  },
};
